import CoreApi from "@/src/modules/core/api";

class HouseholdAssistApi extends CoreApi {
  search(q: string) {
    return this.post("dispatch/household-assist/search", {q});
  }
}

export const householdAssistApi = new HouseholdAssistApi();
